export default [
  {
    path: '/jar-dashboard',
    name: 'jar-dashboard',
    component: () => import(/* webpackChunkName: "jar" */ './views/JarDashboard.vue'),
    meta: {
      title: 'Joint Annual Review Dashboard (JAR)',
    },
  },
];
